import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BusinessCaseSummaryView from './business-case-summary.presenter';
import { deleteBusinessCase } from '../../views/business-case/business-case.actions';

export const mapStateToProps = state => ({
  authorableText: state.authorableContentReducer.authorableContent.myBusinessCases.businessCaseList,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    deleteBusinessCase,
  }, dispatch),
});

const BusinessCaseSummary = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BusinessCaseSummaryView);

export default BusinessCaseSummary;
